import { inject, Injectable } from "@angular/core";
import { openWinClass, jkAlert } from "./jkClass";
import { jkLib } from "./jkCommon";
import { jkRestReturn, IopenWin } from "./jkInterface";
import { login, LoginService } from "./jkUser";



class JkCheckStore {
  mainTable?: string;
  item?: string;
  type?: string;
  dt?: Date;
  constructor() {

  }
}



@Injectable({
  providedIn: 'root',
})
export class JkCatchOpenWin {
  storeRecord: JkCheckStore[] = [];
  programId: string = 'default';
  login: LoginService; //= inject(LoginService);
  constructor() { //
    this.login= login;
  }
  init(programId: string) {
    this.programId = programId;
    let s = localStorage.getItem(this.programId + '_store');
    this.storeRecord = JSON.parse(s as string);
  }
  //async getopenwin(maintable: string, item: string, type: string, ret: jkRestReturn): Promise<void> {
  async getopenwin(owOpt: openWinClass, ret: jkRestReturn): Promise<openWinClass> {
    //let  owOpt = new openWinClass();
    ret.clear();
    let mUrl = '/db/getopenwin';
    let urlParam = '';
    // let param = JSON.stringify(params);
    urlParam = 'maintable=' + owOpt.mainTable + '&type=' + owOpt.type + '&item=' + owOpt.item;

    ret = await jkLib.doFetch(  this.login.hostName, mUrl, urlParam,  this.login.token, 'get');
    //let mRet = jkBDb.GetDataSet(mUrl, data);
    //localStorage.setItem(maintable + '_' + item, JSON.stringify(data));
    //console.log(data);
    let data = JSON.parse(ret.data);
    if (data.result) {
      //owOpt.mainTable = maintable;
      //owOpt.item = item;
      //owOpt.type = type;
      owOpt.title = data.title; //
      owOpt.sqlSelect = data.sqlSelect;
      owOpt.where = data.where;
      let s: string = data.order;
      if (s.toLowerCase().indexOf('order by') < 0) {
        owOpt.order = '';
      } else {
        owOpt.order = data.order;
      };
      owOpt.PS = data.PS;
      owOpt.display = data.display;
      owOpt.map = data.map;
      owOpt.sqlReturn = data.sqlReturn;
      ret.result = true;
    } else {
      jkAlert(data.errorLog);
    }
    return owOpt;
  }
  async reFreshAll(n: number) {
    // 超過天數 重取資料
  }
  async isReload(type: string, maintable: string, item: string, expire: number): Promise<boolean> {
    if (expire <= 0) {
      return true;
    }
    let r = 'query';// 由server 取資料 load
    let d = this.storeRecord.find((element) => {
      if ((element.item === item) &&
        (element.mainTable === maintable) &&
        (element.type === type)) {
        return element;
      } else {
        return null;
      }
    });
    if (d) {
      // // TODO: 檢查過期
      return true;
    } else
      return false;
  }

  makeKey(type: string, maintable: string, item: string): string {
    return type + '_' + maintable + '_' + item;
  }
  // type: W V S
  async doOpenWin_get(type: string, maintable: string, item: string, params: any[],
    expireDay: number = 0,// 0 永遠從server抓
    openWin: IopenWin
  ): Promise<any> {
    if (!openWin) {
      openWin = new openWinClass();
    }
    let b = true;
    if (expireDay > 0) {
      b = await this.isReload(type, maintable, item, expireDay);
    }
    if (!b) {
      let key = this.makeKey(type, maintable, item);
      let d = localStorage.getItem(key);
    } else {

      let mUrl = '';
      let urlParam = '';
      /*if (type==='W') {
        mUrl = '/db/openwin';
      } else {
        mUrl = '/db/valid';
      }; */
      mUrl = '/db/openwin';
      let param = '';
      param = JSON.stringify(params);

      urlParam = 'maintable=' + maintable + '&type=' + type + '&item=' + item + '&params=' + param;
      const data = await jkLib.doFetch( this.login.hostName, mUrl, urlParam,  this.login.token, 'get');
      //let mRet = jkBDb.GetDataSet(mUrl, data);
      //localStorage.setItem(maintable + '_' + item, JSON.stringify(data));
      //console.log(data);
      if (data.result) {
        openWin = JSON.parse(data.data);
        //jkLib.cloneObject(owOpt, openWin);
      } else {
        jkAlert(data.errorLog);
      }
      return data.obj;
    }
  }
  async doOpenWin<T>(type: string, maintable: string, item: string, params: any[],
    expireDay: number = 0// 0 永遠從server抓
  ): Promise<T> {
    let openWinIn: openWinClass = new openWinClass();
    openWinIn.type = type;
    openWinIn.mainTable = maintable;
    openWinIn.item = item;

    let openWinOut: openWinClass = new openWinClass();
    return await this.doOpenWin2(params, expireDay, openWinIn, openWinOut);
  }
  // type: W V S

  async doOpenWin2(params: any[],
    expireDay: number,// 0 永遠從server抓
    openWinIn: openWinClass, openWinOut: openWinClass
  ): Promise<any> {
    openWinOut.clear();
    if ((openWinIn.mainTable === '') || (openWinIn.item === '')) {
      alert('doOpenWin2 開窗mainTable,item 不可為空');
      return;
    }
    let b = true;
    if (expireDay > 0) {
      b = await this.isReload(openWinIn.type, openWinIn.mainTable, openWinIn.item, expireDay);
    }
    if (!b) {
      let key = this.makeKey(openWinIn.type, openWinIn.mainTable, openWinIn.item);
      let d = localStorage.getItem(key);
    } else {

      let mUrl = '';
      let urlParam = '';
      let body = {
        mainTable: openWinIn.mainTable,
        item: openWinIn.item,
        type: openWinIn.type,
        where: openWinIn.where,
        order: openWinIn.order,
        params: params
      };
      /*if (type==='W') {
        mUrl = '/db/openwin';
      } else {
        mUrl = '/db/valid';
      }; */
      mUrl = '/db/openwin';
      //let param = '';
      //param = JSON.stringify(params);

      //urlParam = 'maintable=' + maintable + '&type=' + type + '&item=' + item + '&params=' + param;
      //const data = await jkLib.doFetch( this.login.hostName, mUrl, urlParam,  this.login.token, 'get');
      const data = await jkLib.doFetch( this.login.hostName, mUrl, urlParam,  this.login.token, 'post', body);
      //let mRet = jkBDb.GetDataSet(mUrl, data);
      //localStorage.setItem(maintable + '_' + item, JSON.stringify(data));
      //console.log(data);
      if (data.result) {
        openWinOut = JSON.parse(data.data);
      } else {
        jkAlert(data.errorLog);
      }
      return data.obj;
    }
  }
  async doQuery(ow: IopenWin, ret: jkRestReturn): Promise<any> {
    let mUrl = '/db/query';
    let urlParam = '';
    ret = await jkLib.doFetch( this.login.hostName, mUrl, urlParam,  this.login.token, 'post', ow);
    //let mRet = jkBDb.GetDataSet(mUrl, data);
    //localStorage.setItem(maintable + '_' + item, JSON.stringify(data));
    //console.log(data);
    if (!ret.result) {
      jkAlert('XXXdoQuery:' + ret.errorLog);
      return null;
    } else {
      //itemList = ret.obj;
      return ret.obj;
    }
  }

}

//export const jkOpenWin: JkCatchOpenWin = new JkCatchOpenWin();
